// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"8c0d28b6","127":"2a475581","147":"34088c69","630":"a85e3703","907":"5fa0cd7d","965":"16150c24"}[chunkId] + ".chunk.js";
};